export { default as Details } from './Details';
export { default as UploadDoc } from './Modal_UploadDoc';
